module.exports = __webpack_public_path__ + "static/img/pic04.6d36f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunkang/pic04.png
// module id = 8PUq
// module chunks = 2